import { KeyValue } from '@/main/models/common';
import { MunicipalityFilterRequest } from '@/main/models/request';

export enum MunicipalityTypes {
  GET_MUNICIPALITY = '@municipality/GET_MUNICIPALITY',
  SAVE_MUNICIPALITY = '@municipality/SAVE_MUNICIPALITY',
  RESET_REDUCER_MUNICIPALITY = '@municipality/RESET_REDUCER_MUNICIPALITY'
}

export interface MunicipalityState {
  readonly municipality: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetMunicipality {
  type: typeof MunicipalityTypes.GET_MUNICIPALITY;
  payload: {
    request: MunicipalityFilterRequest;
  };
}

export interface SaveMunicipality {
  type: typeof MunicipalityTypes.SAVE_MUNICIPALITY;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerMunicipality {
  type: typeof MunicipalityTypes.RESET_REDUCER_MUNICIPALITY;
}

export type MunicipalityActionTypes =
  | GetMunicipality
  | SaveMunicipality
  | ResetReducerMunicipality;
